import { Injectable } from '@angular/core';

import { RidangoReduxAction, Product, ProductNotifications } from '@ridango/core';
import { MediumType } from '../../medium/medium.model';
import { CustomerAction } from '../../../lib/customer';

@Injectable()
export class PurchaseActions {
    static SET_WALLET_PURCHASE_STEPS = '[Purchase Wallet] Set Purchase Steps';
    static SET_WALLET_ACTIVE_PURCHASE_STEP = '[Purchase Wallet] Set Active Purchase Step';

    static PREPARE_CORPORATE_PAYLOADS = '[Purchase] Prepare corporate payloads';
    static REMOVE_CORPORATE_TRAVEL_CARD = '[Purchase] Remove corporate travelcard';

    static SET_WALLET_SELECTED_PRODUCT = '[Purchase Wallet] Set Selected Product';
    static SET_WALLET_SELECTED_PRODUCT_QTY = '[Purchase Wallet] Set Selected Product Quantity';
    static SET_WALLET_SELECTED_SUM = '[Purchase Wallet] Set Selected Sum';
    static REMOVE_WALLET_SELECTED_SUM = '[Purchase Wallet] Remove Selected Sum';
    static SET_WALLET_SELECTED_MEDIUM_RELATED_CARD = '[Purchase Wallet] Set Selected Medium Related Card';
    static SET_WALLET_SELECTED_MEDIUM_TRAVEL_CARD = '[Purchase Wallet] Set Selected Medium Travel Card';
    static SET_WALLET_SELECTED_MEDIUM_EMAIL = '[Purchase Wallet] Set Selected Medium Email';
    static SET_WALLET_IS_FLOW_COMPLETED = '[Purchase Wallet] Set Is Flow Completed';

    static SET_PRODUCT_NOTIFICATIONS = '[Purchase Wallet] Set Product Notifications';
    static RESET_PRODUCT_NOTIFICATIONS = '[Purchase Wallet] Reset Product Notifications';
    static SET_PRODUCT_NOTIFICATIONS_FORM_VALIDITY = '[Purchase Wallet] Set Product Notifications Form Validity';

    static SET_PURCHASE_SHOPPING_CART_ID = '[Purchase] Set Purchase Shopping Cart Id';
    static UNSET_PURCHASE_SHOPPING_CART_ID = '[Purchase] UnSet Purchase Shopping Cart Id';

    static CLEAR_PURCHASE_SELECTIONS = '[Purchase Wallet] Clear Purchase Selections';

    static RESET_WALLET_PURCHASE = '[Purchase Wallet] Reset';

    static UNSET_TICKET_PURCHASE_MEDIUM = '[Purchase Ticket] Unset Medium';
    static UNSET_TICKET_PURCHASE_PRODUCT = '[Purchase Ticket] Unset Product';

    static SET_TICKET_PURCHASE_AREA = '[Purchase Ticket] Set Area';
    static SET_TICKET_PURCHASE_ZONES = '[Purchase Ticket] Set Zones';

    static SET_PURCHASE_REGION = '[Purchase] Set Region';
    static SET_CART_LANGUAGE = '[Purchase] Set Cart Language';

    static SET_INVOICE_LOADING = '[Purchase] Set Invoice Loading';

    static SET_TICKET_VALIDITY_DATES = '[Purchase] Set validity dates';
    static UNSET_TICKET_VALIDITY_DATES = '[Purchase] Reset validity dates';

    static SET_CHANNEL = '[Purchase] Set Purchase Shopping Cart Channel';

    static FETCH_CATEGORY_PRODUCT_DETAILS = '[Purchase]: Fetch category product details';
    static FETCH_CATEGORY_PRODUCT_DETAILS_SUCCESS = '[Purchase]: Fetch category product details success';
    static FETCH_CATEGORY_PRODUCT_DETAILS_FAILED = '[Purchase]: Fetch category product details failed';

    handleCategoryProductDetailsSuccess(payload): CustomerAction {
        return {
            type: PurchaseActions.FETCH_CATEGORY_PRODUCT_DETAILS_SUCCESS,
            payload: payload
        };
    }

    handleCategoryProductDetailsFailed(payload): CustomerAction {
        return {
            type: PurchaseActions.FETCH_CATEGORY_PRODUCT_DETAILS_FAILED,
            payload: payload
        };
    }

    setCustomerProfile(payload): CustomerAction {
        return {
            type: PurchaseActions.FETCH_CATEGORY_PRODUCT_DETAILS_SUCCESS,
            payload: payload
        };
    }

    setWalletPurchaseSteps(payload: any[]): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_WALLET_PURCHASE_STEPS,
            payload: payload
        };
    }

    setChannel(payload: string): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_CHANNEL,
            payload: payload
        };
    }
    setActiveWalletPurchaseStep(payload: number): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_WALLET_ACTIVE_PURCHASE_STEP,
            payload: payload
        };
    }

    prepareCorporatePayloads(payload: any): RidangoReduxAction {
        return {
            type: PurchaseActions.PREPARE_CORPORATE_PAYLOADS,
            payload: payload
        };
    }

    removeCorporateTravelCard(payload: any): RidangoReduxAction {
        return {
            type: PurchaseActions.REMOVE_CORPORATE_TRAVEL_CARD,
            payload: payload
        };
    }

    setWalletSelectedProduct(payload: Product): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_WALLET_SELECTED_PRODUCT,
            payload: payload
        };
    }

    setWalletSelectedProductQuantity(payload: Product[]): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_WALLET_SELECTED_PRODUCT_QTY,
            payload: payload
        };
    }

    setProductNotifications(payload: ProductNotifications): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_PRODUCT_NOTIFICATIONS,
            payload: payload
        };
    }

    ResetProductNotifications(): RidangoReduxAction {
        return {
            type: PurchaseActions.RESET_PRODUCT_NOTIFICATIONS
        };
    }

    setProductNotificationFormValidity(payload: boolean): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_PRODUCT_NOTIFICATIONS_FORM_VALIDITY,
            payload: payload
        };
    }

    setWalletSelectedSum(payload: number): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_WALLET_SELECTED_SUM,
            payload: payload
        };
    }
    removeWalletSelectedSum(): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_WALLET_SELECTED_SUM
        };
    }
    setWalletSelectedMedium(payload: any): RidangoReduxAction {
        let action: RidangoReduxAction = {
            type: PurchaseActions.SET_WALLET_SELECTED_MEDIUM_TRAVEL_CARD,
            payload: payload
        };
        if (payload.type === MediumType.RelatedCard) {
            action = {
                type: PurchaseActions.SET_WALLET_SELECTED_MEDIUM_RELATED_CARD,
                payload: payload
            };
        }
        if (payload.type === MediumType.Email) {
            action = {
                type: PurchaseActions.SET_WALLET_SELECTED_MEDIUM_EMAIL,
                payload: payload
            };
        }
        return action;
    }

    setWalletIsFlowCompleted(payload: boolean): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_WALLET_IS_FLOW_COMPLETED,
            payload: payload
        };
    }
    setPurchaseShoppingCartId(payload: number): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_PURCHASE_SHOPPING_CART_ID,
            payload: payload
        };
    }

    clearWalletPurchaseSelections(): RidangoReduxAction {
        return {
            type: PurchaseActions.CLEAR_PURCHASE_SELECTIONS
        };
    }

    resetWalletPurchase(): RidangoReduxAction {
        return {
            type: PurchaseActions.RESET_WALLET_PURCHASE
        };
    }

    unsetShoppingCartId(): RidangoReduxAction {
        return {
            type: PurchaseActions.UNSET_PURCHASE_SHOPPING_CART_ID
        };
    }
    unsetProduct(): RidangoReduxAction {
        return {
            type: PurchaseActions.UNSET_TICKET_PURCHASE_PRODUCT
        };
    }
    unsetMedium(): RidangoReduxAction {
        return {
            type: PurchaseActions.UNSET_TICKET_PURCHASE_MEDIUM
        };
    }

    setTicketPurchaseArea(area): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_TICKET_PURCHASE_AREA,
            payload: area
        };
    }

    setTicketPurchaseZones(start_zone_id, end_zone_id, start_zone_name, end_zone_name): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_TICKET_PURCHASE_ZONES,
            payload: { start_zone_id, end_zone_id, start_zone_name, end_zone_name }
        };
    }

    setTicketValidityDates(starting, ending): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_TICKET_VALIDITY_DATES,
            payload: { starting, ending }
        };
    }

    unsetTicketValidityDates(): RidangoReduxAction {
        return {
            type: PurchaseActions.UNSET_TICKET_VALIDITY_DATES
        };
    }

    setRegion(region_id: number): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_PURCHASE_REGION,
            payload: region_id
        };
    }

    setCartLanguage(language: string): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_CART_LANGUAGE,
            payload: language
        };
    }

    setInvoiceLoading(loading: boolean): RidangoReduxAction {
        return {
            type: PurchaseActions.SET_INVOICE_LOADING,
            payload: loading
        };
    }
}
